import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Printer, X } from 'lucide-react';

const PrintVehicleModal = ({ isOpen, onClose, vehicles, onPrint }) => {
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const enconOrange = '#ee7203';

  const toggleVehicle = (vehicleId) => {
    setSelectedVehicles(prev => 
      prev.includes(vehicleId) 
        ? prev.filter(id => id !== vehicleId)
        : [...prev, vehicleId]
    );
  };

  const selectAll = () => {
    setSelectedVehicles(vehicles.map(v => v.id));
  };

  const deselectAll = () => {
    setSelectedVehicles([]);
  };

  const handlePrint = () => {
    if (selectedVehicles.length === 0) {
      return;
    }
    onPrint(selectedVehicles);
    onClose();
    setSelectedVehicles([]);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Printer className="w-5 h-5" style={{ color: enconOrange }} />
            Select Vehicles to Print
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          {/* Select All / Deselect All */}
          <div className="flex gap-2">
            <button
              onClick={selectAll}
              className="flex-1 px-3 py-2 text-sm rounded-lg border hover:bg-gray-50"
              style={{ borderColor: enconOrange, color: enconOrange }}
            >
              Select All
            </button>
            <button
              onClick={deselectAll}
              className="flex-1 px-3 py-2 text-sm rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50"
            >
              Deselect All
            </button>
          </div>

          {/* Vehicle List */}
          <div className="max-h-96 overflow-y-auto space-y-2">
            {vehicles.map((vehicle) => (
              <label
                key={vehicle.id}
                className="flex items-center gap-3 p-3 rounded-lg border cursor-pointer hover:bg-gray-50 transition-colors"
                style={{
                  borderColor: selectedVehicles.includes(vehicle.id) ? enconOrange : '#e5e7eb',
                  backgroundColor: selectedVehicles.includes(vehicle.id) ? 'rgba(238, 114, 3, 0.05)' : 'white'
                }}
              >
                <input
                  type="checkbox"
                  checked={selectedVehicles.includes(vehicle.id)}
                  onChange={() => toggleVehicle(vehicle.id)}
                  className="w-4 h-4 rounded"
                  style={{ accentColor: enconOrange }}
                />
                <div className="flex-1">
                  <div className="font-semibold text-gray-900">
                    {vehicle.vehicle_registration}
                  </div>
                  <div className="text-sm text-gray-500">
                    {vehicle.driver_name || 'No driver assigned'}
                    {vehicle.vehicle_type && (
                      <span className="ml-2 text-xs px-1.5 py-0.5 rounded bg-gray-100 text-gray-600">{vehicle.vehicle_type}</span>
                    )}
                  </div>
                </div>
              </label>
            ))}
          </div>

          {/* Print Button */}
          <div className="flex gap-2 pt-4 border-t">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              onClick={handlePrint}
              disabled={selectedVehicles.length === 0}
              className="flex-1 px-4 py-2 rounded-lg text-white font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
              style={{ backgroundColor: enconOrange }}
            >
              Print {selectedVehicles.length > 0 && `(${selectedVehicles.length})`}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PrintVehicleModal;
